import { BaseService } from '../base';

/** Um CAEPF retornado pela consulta. */
export type CaepfEntry = {
  registrationNumber: string | null;
  responsibleName: string | null;
  activityStartDate: string | null;
  registrationStatus: string | null;
  certificateIssuedAt: string | null;
  certificateCode: string | null;
};

/**
 * Um CPF pode ter VÁRIOS CAEPFs vinculados. Os 6 campos do topo espelham o
 * primeiro item (contrato antigo, preservado); `items` traz todos.
 */
export type CaepfResponse = CaepfEntry & {
  items: CaepfEntry[];
  /** `false` quando a consulta não retornou nenhum CAEPF. */
  hasCaepf: boolean;
};

export class CaepfService extends BaseService {
  async getCaepf(document: string): Promise<{
    success: boolean;
    data?: CaepfResponse;
    error?: string;
    status?: number;
  }> {
    try {
      const clean = (document ?? '').replace(/\D/g, '');
      const path = `/portal/v1/services/caepf/${clean}`;
      const response = await this.get(path, {}, import.meta.env.VITE_API_URL);
      const result = await this.handleJsonResponse<CaepfResponse>(response);
      return { ...result, status: response.status };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : 'Erro ao consultar CAEPF',
      };
    }
  }
}

export const caepfService = new CaepfService();

/** Situação cadastral considerada regular para CAEPF (Compliance.Api). */
export const CAEPF_ACTIVE_STATUS = 'ATIVA';
